// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    buttonText: {
        type: FIELD_TYPES.TEXT,
        label: "Button Text",
        translatable: true
    },
    card1Text: {
        type: FIELD_TYPES.TEXT,
        label: "Card 1 Text",
        translatable: true
    },
    card1Title: {
        type: FIELD_TYPES.TEXT,
        label: "Card 1 Title",
        translatable: true
    },
    card2Text: {
        type: FIELD_TYPES.TEXT,
        label: "Card 2 Text",
        translatable: true
    },
    card2Title: {
        type: FIELD_TYPES.TEXT,
        label: "Card 2 Title",
        translatable: true
    },
    card3Text: {
        type: FIELD_TYPES.TEXT,
        label: "Card 3 Text",
        translatable: true
    },
    card3Title: {
        type: FIELD_TYPES.TEXT,
        label: "Card 3 Title",
        translatable: true
    },
    card4Text: {
        type: FIELD_TYPES.TEXT,
        label: "Card 4 Text",
        translatable: true
    },
    card4Title: {
        type: FIELD_TYPES.TEXT,
        label: "Card 4 Title",
        translatable: true
    },
    card5Text: {
        type: FIELD_TYPES.TEXT,
        label: "Card 5 Text",
        translatable: true
    },
    card5Title: {
        type: FIELD_TYPES.TEXT,
        label: "Card 5 Title",
        translatable: true
    },
    card6Text: {
        type: FIELD_TYPES.TEXT,
        label: "Card 6 Text",
        translatable: true
    },
    card6Title: {
        type: FIELD_TYPES.TEXT,
        label: "Card 6 Title",
        translatable: true
    },
    comingSoon: {
        type: FIELD_TYPES.TEXT,
        label: "Coming Soon",
        translatable: true
    },
    secondButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Second Button Text",
        translatable: true
    },
    subTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Sub Title",
        translatable: true
    },
    title: {
        type: FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    card1ImageOnHover: {
        type: FIELD_TYPES.NESTED,
        label: "Card 1 Image On Hover",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card2ImageOnHover: {
        type: FIELD_TYPES.NESTED,
        label: "Card 2 Image On Hover",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card3ImageOnHover: {
        type: FIELD_TYPES.NESTED,
        label: "Card 3 Image On Hover",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card4ImageOnHover: {
        type: FIELD_TYPES.NESTED,
        label: "Card 4 Image On Hover",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card5ImageOnHover: {
        type: FIELD_TYPES.NESTED,
        label: "Card 5 Image On Hover",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card6ImageOnHover: {
        type: FIELD_TYPES.NESTED,
        label: "Card 6 Image On Hover",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    }
};
